@if (changeIndicator?.value !== undefined && changeIndicator?.value !== null) {
<mat-chip
  [class.kpi-chip-improved]="improved"
  [class.kpi-chip-worsened]="worsened"
  [class.kpi-chip-steady]="steady"
  class="mat-standard-chip"
>
  {{ changeIndicator?.value | number: "0.0-1" }} mins
</mat-chip>
}
